var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommunication(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 11.3633C17.66 11.3633 18.99 10.0233 18.99 8.36328C18.99 6.70328 17.66 5.36328 16 5.36328C14.34 5.36328 13 6.70328 13 8.36328C13 10.0233 14.34 11.3633 16 11.3633ZM8 11.3633C9.66 11.3633 10.99 10.0233 10.99 8.36328C10.99 6.70328 9.66 5.36328 8 5.36328C6.34 5.36328 5 6.70328 5 8.36328C5 10.0233 6.34 11.3633 8 11.3633ZM8 13.3633C5.67 13.3633 1 14.5333 1 16.8633V18.3633C1 18.9133 1.45 19.3633 2 19.3633H14C14.55 19.3633 15 18.9133 15 18.3633V16.8633C15 14.5333 10.33 13.3633 8 13.3633ZM16 13.3633C15.71 13.3633 15.38 13.3833 15.03 13.4133C15.05 13.4233 15.06 13.4433 15.07 13.4533C16.21 14.2833 17 15.3933 17 16.8633V18.3633C17 18.7133 16.93 19.0533 16.82 19.3633H22C22.55 19.3633 23 18.9133 23 18.3633V16.8633C23 14.5333 18.33 13.3633 16 13.3633Z",
    fill: "#EBD28D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunication);
export default __webpack_public_path__ + "static/media/Communication.3b070401894f1c5bc5a6221f4cd9b563.svg";
export { ForwardRef as ReactComponent };